import React from "react";
import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>
              System administrator with five years of experience performing system repairs and
              troubleshooting. Expertise in deploying and maintaining operating systems and
              providing technical solutions through high-quality service
                <br />
                
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Web Development</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>English</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Image" />
                  <h5>German</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>DevOps</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Selenium</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>Docker</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Level 1 Support</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Level 2 Support</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Level 3 Support</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>Ansimble</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Cybersecurity Analyst</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>Backend Developer</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>Device Management</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Technical Documentation</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Technical Support</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>Machine Learning Engineer</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Image" />
                  <h5>Windows Server, Linux
                  Server</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Image" />
                  <h5>Virtualization (KVM VMware, Docker)</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>MDM (Mobile Device Management)</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Cloud-Based System
                      Management (AWS, GCP,Azura)
                  </h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>Communication (Writing, Speaking, Reading)</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Complex Analyst</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Image" />
                  <h5>Automation scripting
                      (Bash, Python)
                  </h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Image" />
                  <h5>  Zabbix,Microsoft Intune</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img
        className="background-image-left"
        src={colorSharp}
        alt="Background"
      />
    </section>
  );
};
